<template>
	<v-layout row>
		<v-flex xs12 md8>
			<v-card style="margin: 10px">
				<v-card-title class="blue white--text">
					<h3>Projekt</h3>
				</v-card-title>
				<v-card-text>
					<display-text-component
						:flex="'equal'"
						label="Numer"
						:value="projectData.projectCode"/>
					<display-text-component
						:flex="'equal'"
						label="Suma kontrolna"
						:value="projectData.controlSum"/>
					<display-text-component
						:flex="'equal'"
						label="Wersja"
						:value="projectData.projectVersion"/>
					<display-text-component
						:flex="'equal'"
						class="no-print"
						label="Nazwa"
						:value="projectData.title"/>
					<display-text-component v-if="projectData.sendDate !== null"
						:flex="'equal'"
						label="Data wysłania"
						:value="projectData.sendDate"/>
					<display-text-component
						:flex="'equal'"
						label="Projekt wspólny"
						:value="projectData.mutualProject ? 'TAK' : 'NIE'"/>
				</v-card-text>
			</v-card>
		</v-flex>
		<v-flex xs12 md4>
			<v-card style="margin: 10px">
				<v-card-title style="background-color: #0075e2; color: #fff">
					<h3>Kwota dotacji</h3>
				</v-card-title>
				<v-card-text>
					<display-text-component
						label="Łącznie"
						:value="getFormatted(requestedDotation) +  ' PLN'"/>
				</v-card-text>
			</v-card>
		</v-flex>
	</v-layout>
</template>

<script>
	import DisplayTextComponent from "../offer/components/DisplayTextComponent";
	import {Numbers} from "@/utils/Numbers";

	export default {
		name: "ProjectReadOnlyHeader",

		components: {DisplayTextComponent},

		mixins: [Numbers],

		methods: {
			getFormatted (value) {
				return Numbers.methods.formatMoney(value);
			}
		},

		props: {
			projectData: Object,
			requestedDotation: [String, Number]
		}
	};
</script>

<style scoped>

</style>